import {
  ContractDetailPartyResponse,
  ContractLifecycleEventResponse,
} from 'compliance-api/generated';
import { useId } from 'react';
import { ContractByIDContributorsTab } from '@/modules/admin-dashboard/components/contractManagement/ContractByID/ContractByIDContributorsTab.tsx';
import { ContractByIDNotesTab } from '@/modules/admin-dashboard/components/contractManagement/ContractByID/ContractByIDNotesTab.tsx';
import { ContractByIDPartiesTab } from '@/modules/admin-dashboard/components/contractManagement/ContractByID/ContractByIDPartiesTab.tsx';
import {
  ContractByIDDetailsTab,
  type ContractByIDTabName,
} from '@/modules/admin-dashboard/components/contractManagement/ContractByID/ContractDetailsTab.tsx';
import { TabButtons, TabItem, Tabs } from 'ui';

export type ContractInfoTab = ContractByIDTabName;

const CONTRACT_INFO_TABS: TabItem<ContractInfoTab>[] = [
  {
    name: 'details',
    label: 'Details',
    container: <div />,
  },
  {
    name: 'parties',
    label: 'Parties',
    container: <div />,
  },
  {
    name: 'contributors',
    label: 'User Access',
    container: <div />,
  },
  // {
  //   name: 'tasks',
  //   label: 'Tasks',
  //   container: <div />,
  // },
  {
    name: 'notes',
    label: 'Notes',
    container: <div />,
  },
];

interface ContractByIDRightPanelProps {
  contractId: number;
  clientId?: number;
  parties: ContractDetailPartyResponse[];
  lifecycleEvents: ContractLifecycleEventResponse[];
  activeTab: ContractInfoTab;
  setActiveTab: (tab: ContractInfoTab) => void;
  readOnly: boolean;
}

export const ContractByIDRightPanel = ({
  contractId,
  clientId,
  parties,
  lifecycleEvents,
  activeTab,
  setActiveTab,
  readOnly,
}: ContractByIDRightPanelProps) => {
  const disabledTooltipId = useId();

  return (
    <div className="relative z-10 flex w-full flex-col bg-white lg:w-[412px] lg:max-w-[412px] lg:shrink-0 lg:h-[calc(100vh-71px)] lg:overflow-hidden">
      <div className="border-b border-gray-200 bg-white px-5 pt-4">
        <TabButtons<ContractInfoTab>
          tabs={CONTRACT_INFO_TABS.map(tab =>
            tab.name === 'tasks' && !clientId
              ? {
                  ...tab,
                  disabled: true,
                  disabledReason: 'Tasks are available after a client is assigned.',
                }
              : tab,
          )}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          disabledTooltipId={disabledTooltipId}
          className="h-[38px] [&>div]:w-full [&>div]:px-4 [&>div]:justify-between overflow-x-auto overflow-y-hidden sm:h-[34px]"
        />
      </div>

      <div
        id="contract-by-id-right-panel-content"
        className="min-h-0 flex-1 overflow-y-auto bg-white px-5 py-4"
      >
        <Tabs
          items={[
            {
              ...CONTRACT_INFO_TABS[0],
              container: <ContractByIDDetailsTab readOnly={readOnly} />,
            },
            {
              ...CONTRACT_INFO_TABS[1],
              container: (
                <ContractByIDPartiesTab
                  contractId={contractId}
                  parties={parties}
                  readOnly={readOnly}
                />
              ),
            },
            // {
            //   ...CONTRACT_INFO_TABS[3],
            //   container: <ContractByIDTasksTab clientId={clientId} />,
            // },
            {
              ...CONTRACT_INFO_TABS[2],
              container: (
                <ContractByIDContributorsTab contractId={contractId} readOnly={readOnly} />
              ),
            },
            {
              ...CONTRACT_INFO_TABS[3],
              container: (
                <ContractByIDNotesTab
                  contractId={contractId}
                  lifecycleEvents={lifecycleEvents}
                  readOnly={readOnly}
                />
              ),
            },
          ]}
          activeTab={activeTab}
        />
      </div>
    </div>
  );
};
